// TODO(boundaries) Fix after modernizing architecture
/* eslint-disable @nx/enforce-module-boundaries */
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import {enableProdMode, ErrorHandler, LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TitleStrategy, provideRouter } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideRouterStore } from '@ngrx/router-store';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import 'hammerjs';
import { provideQuillConfig } from 'ngx-quill';

import { provideQueryClient } from '@core/shared/data-access';
import {
  AbstractThemeChangesTrackingService,
  GlobalErrorHandlerService,
  InsightsEventsTrackingService,
  ThemeChangesTrackingDevService,
  provideCustomSvgIconRegistry,
} from '@core/shared/util';
import { NewsPermissions } from '@mp/dashboard/newsfeed/feature';
import { AppInsightsFacade } from '@mp/shared/app-insights/data-access';
import { provideAppInsightsFeature } from '@mp/shared/app-insights/feature';
import { InsightsOrganizationInfoService } from '@mp/shared/app-insights/util';
import { HttpErrorInterceptor, PlatformRouterSerializer, provideSharedDataAccess } from '@mp/shared/data-access';
import { JobServerPermissions, ObservabilityPermissions } from '@mp/shared/feature';
import { AbstractLinkProviderService, provideModuleInfo } from '@mp/shared/util';
import { DeploymentSettingsPermissions } from '@mp/system/deployment-settings/feature';
import { PlatformPackagingUnitsPermissions } from '@mp/system/platform-packaging-units/feature';
import { ActiveOrganizationInterceptor, provideProfileDataAccess } from '@mpauth/shared/data-access';
import { provideBusinessIntelligenceFeature } from '@mpbi/feature';
import { provideContentManagerFeature } from '@mpcm/feature';
import { provideContractManagementFeature } from '@mpctm/feature';
import { provideExportFeature } from '@mpem/feature';
import { provideAmor3Feature } from '@mpia/feature';
import { provideGhxFeature } from '@mpig/feature';
import { provideMediioFeature } from '@mpim/feature';
import { provideKernelFeature } from '@mpk/feature';
import { AbstractAuthInfoProviderService, provideModulePermissions } from '@mpk/shared/data-access';
import { provideOrganizationMasterDataFeature } from '@mpomd/feature';
import { provideSupplierManagementFeature } from '@mpsm/feature';
import { provideClinicSupplierAddressCodesFeature } from '@mpsm/shared/feature';

import { AppComponent } from './app/app.component';
import { REDUCERS_TOKEN, reducerProvider } from './app/app.reducer';
import { routes } from './app/app.routes';
import { AppInsightsOrganizationInfoService, AuthInfoProviderService } from './app/auth';
import { CUSTOM_DATE_FORMATS, CustomDatePickerAdapter } from './app/date-adapter';
import { AppTitleStrategy } from './app/info/app-title-strategy';
import { appInitProvider } from './app/init/app-init.service';
import { LinkProviderService } from './app/navigation';
import { environment } from './environments/environment';

registerLocaleData(localeDe, 'de', localeDeExtra);

bootstrapApplication(AppComponent, {
  providers: [
    // Angular providers
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ActiveOrganizationInterceptor,
      multi: true,
    },

    // Material providers
    { provide: DateAdapter, useClass: CustomDatePickerAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    provideCustomSvgIconRegistry(),

    // Ngrx state management providers
    provideStore(REDUCERS_TOKEN, {
      runtimeChecks: {
        strictActionImmutability: true,
        strictStateImmutability: true,
      },
    }),
    reducerProvider,
    provideEffects(),
    provideRouterStore({ serializer: PlatformRouterSerializer }),
    !environment.production ? provideStoreDevtools() : [],

    provideQueryClient(),

    provideQuillConfig({}),

    provideAppInsightsFeature(),

    // App specific providers
    appInitProvider,
    provideSharedDataAccess(),
    provideProfileDataAccess(),
    provideKernelFeature(),
    provideOrganizationMasterDataFeature(),
    provideBusinessIntelligenceFeature(),
    provideContentManagerFeature(),
    provideSupplierManagementFeature(),
    provideContractManagementFeature(),
    provideClinicSupplierAddressCodesFeature(),
    provideExportFeature(),
    provideModuleInfo('Jobs', {
      displayName: 'Jobs',
    }),
    provideModulePermissions('Jobs', JobServerPermissions),
    provideModuleInfo('Observability', {
      displayName: 'Logging',
    }),
    provideModulePermissions('Observability', ObservabilityPermissions),
    provideModulePermissions('Kernel', NewsPermissions, DeploymentSettingsPermissions),
    provideModulePermissions('ContentManager', PlatformPackagingUnitsPermissions),
    provideAmor3Feature(),
    provideGhxFeature(),
    provideMediioFeature(),

    { provide: AbstractAuthInfoProviderService, useClass: AuthInfoProviderService },
    !environment.production
      ? { provide: AbstractThemeChangesTrackingService, useClass: ThemeChangesTrackingDevService }
      : [],
    { provide: AbstractLinkProviderService, useClass: LinkProviderService },
    { provide: InsightsEventsTrackingService, useExisting: AppInsightsFacade },
    { provide: InsightsOrganizationInfoService, useClass: AppInsightsOrganizationInfoService },
  ],
}).catch((err) => console.error(err));
